module.exports = __webpack_public_path__ + "img/saudia-2.71ce80f2.png";